// 重置浏览器样式
import '$common/style/reset.styl';
import boot from '$boot/boot';
import routerModule from './router';
import pageComponent from './index';
import language from './language';
import DocumentMixin from '$common/utils/vue-plugin/mixins/document-mixin';
import DocumentTitlePlugin from '$common/utils/vue-plugin/document-title';
import ToolMixin from '$common/utils/vue-plugin/mixins/tool-mixin';
import TecalcMixin from '$common/utils/vue-plugin/mixins/recalc-mixin';
import store from './store';
try {
  //  将后端渲染的东西序列化成对象
  window.ssrConfig = JSON.parse(decodeURIComponent(window.ssrConfig));
} catch (err) {}

//  初始化组件
const { i18n, loadLanguageAsync } = language.use(Vue, VueI18n)
const router = routerModule.use(Vue, VueRouter, loadLanguageAsync)
Vue.use(DocumentTitlePlugin)

boot({
  Vue,
  pageComponent,
  before: config => Object.assign({}, config, {
    i18n,
    router,
    mixins: [DocumentMixin, ToolMixin, TecalcMixin, store]
  }),
  after: vm => {
    //  监听语言切换，动态懒加载国际化文案
    vm.$watch('$i18n.locale', val => loadLanguageAsync({
      lang: val
    }).then());
  }
});